import type { RunRecord, Scenario } from '@orgsim/shared';
import { type DBSchema, type IDBPDatabase, openDB } from 'idb';

export type { RunRecord };

interface OrgSimDb extends DBSchema {
  scenarios: { key: string; value: Scenario };
  runs: { key: string; value: RunRecord; indexes: { byStarted: number } };
}

let dbPromise: Promise<IDBPDatabase<OrgSimDb>> | null = null;

function db(): Promise<IDBPDatabase<OrgSimDb>> {
  if (!dbPromise) {
    dbPromise = openDB<OrgSimDb>('orgsim', 1, {
      upgrade(d) {
        d.createObjectStore('scenarios', { keyPath: 'id' });
        const runs = d.createObjectStore('runs', { keyPath: 'id' });
        runs.createIndex('byStarted', 'startedAt');
      },
    });
  }
  return dbPromise;
}

export async function dbAvailable(): Promise<boolean> {
  try {
    await db();
    return true;
  } catch {
    return false;
  }
}

// Scenarios live on the server now. The store stays (same schema version) so scenarios saved
// here by older versions can still be listed and saved to the server by an admin.
export const listLocalScenarios = async () => (await db()).getAll('scenarios');

export const listRuns = async () =>
  (await (await db()).getAllFromIndex('runs', 'byStarted')).reverse();
export const getRun = async (id: string) => (await db()).get('runs', id);
export const putRun = async (r: RunRecord) => (await db()).put('runs', r);
export const deleteRun = async (id: string) => (await db()).delete('runs', id);
